var DnDActions, DragDropTypes;

DnDActions = require('actions/react_dnd_actions');

DragDropTypes = require('components/scope/questions/drag_drop_types');

module.exports = {
  dragSpec: {
    beginDrag: function(props, monitor, component) {
      var id, qIndex;
      id = props.id, qIndex = props.qIndex;
      DnDActions.beginDrag({
        type: DragDropTypes.QUESTION,
        qIndex: qIndex
      });
      return {
        id: id,
        qIndex: qIndex
      };
    },
    isDragging: function(props, monitor) {
      return props.id === monitor.getItem().id;
    },
    endDrag: function(props, monitor) {
      return DnDActions.endDrag();
    },
    canDrag: function(props, monitor) {
      return props.canDrag;
    }
  },
  dropSpec: {
    hover: function(props, monitor, component) {
      if (props.id === monitor.getItem().id) {
        return;
      }
      return DnDActions.hover({
        type: DragDropTypes.QUESTION,
        hoverIndex: props.qIndex
      });
    },
    canDrop: function() {
      return false;
    }
  },
  dragCollect: function(connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    };
  },
  dropCollect: function(connect, monitor) {
    return {
      connectDropTarget: connect.dropTarget()
    };
  }
};
